import { type ComponentProps, forwardRef } from 'react';
import type Animated from 'react-native-reanimated';

import { Scrollspy } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuCategoriesGridContainer = forwardRef<
  Animated.ScrollView,
  MenuCategoriesGridContainerProps
>((props, ref) => {
  const { children, ...restProps } = props;

  return (
    <Scrollspy.ScrollView ref={ref} {...restProps}>
      {children}
    </Scrollspy.ScrollView>
  );
});

// ─── Types ───────────────────────────────────────────────────────────────────

type MenuCategoriesGridContainerProps = ComponentProps<typeof Scrollspy.ScrollView>;
